

export const FETCH_ROLES_REQUEST = 'roles/FETCH_ROLES_REQUEST';
export const FETCH_ROLES_SUCCESS = 'roles/FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'roles/FETCH_ROLES_FAILURE';

export const FETCH_PERMISSIONS_REQUEST = 'roles/FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_SUCCESS = 'roles/FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'roles/FETCH_PERMISSIONS_FAILURE';


export const FETCH_ROLE_REQUEST = 'roles/FETCH_ROLE_REQUEST';
export const FETCH_ROLE_SUCCESS = 'roles/FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_FAILURE = 'roles/FETCH_ROLE_FAILURE';


export const DELETE_ROLE_REQUEST = 'roles/DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'roles/DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'roles/DELETE_ROLE_FAILURE';


export const CREATE_ROLE_REQUEST = 'roles/CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'roles/CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAILURE = 'roles/CREATE_ROLE_FAILURE';


export const UPDATE_ROLE_REQUEST = 'roles/UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'roles/UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILURE = 'roles/UPDATE_ROLE_FAILURE';


export const UPDATE_FIELD = 'roles/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'roles/SET_DEFAULT_DATA';
